export default "__VITE_ASSET__VgCggQ32__"